export const LocationExtent = (location) => {
    let mapextent, mapZoom, graphicsSummaryVisible;
    //Make dynamic at some point.
    switch (location) {
        case 'berberiannut':
            mapextent = [-122.1390, 38.9353];
            mapZoom = 6;
            graphicsSummaryVisible = false;
            break;
        case 'southvalleyfarms':
            mapextent = [-118.1390, 35.9353];
            mapZoom = 6;
            graphicsSummaryVisible = false;
            break;
        case 'agrinorthwest':
            mapextent = [-120.1490, 45.7353];
            mapZoom = 6;
            graphicsSummaryVisible = false;
            break;
        case 'riverpointfarms':
            mapextent = [-121.1390, 44.9353];
            mapZoom = 6;
            graphicsSummaryVisible = false;
            break;
        case 'deseretranches':
            mapextent = [-82.1390, 27.9353];
            mapZoom = 6;
            graphicsSummaryVisible = false;
            break;
        case 'canyonfalls':
            mapextent = [-114.1390, 42.9353];
            mapZoom = 6;
            graphicsSummaryVisible = false;
            break;
        default:
            mapextent = [-100.1490, 38.7353];
            mapZoom = 4;
            graphicsSummaryVisible = true;
    }

    return { mapextent, mapZoom, graphicsSummaryVisible };
};
